import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  style: {"enable-background":"new 0 0 16 16"},
  "xml:space": "preserve",
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-1049"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  d: "m13.964 7.065.153.033c.288-2.849-1.592-5.412-4.186-5.949-2.547-.527-5.323.994-6.018 3.428-.766 2.684.738 4.169.937 4.44-1.462-.316-2.874-2.365-2.814-3.983L1.884 5c-.291 2.851 1.591 5.415 4.186 5.949 2.528.519 5.218-1 5.992-3.399.809-2.51-.704-4.196-.9-4.465 1.554.325 2.863 2.364 2.802 3.98zm-6.202.18a1.22 1.22 0 1 1 .476-2.392 1.22 1.22 0 0 1-.476 2.392zM.993 13.759a1.22 1.22 0 1 0 2.44 0c0-.674-1.22-2.44-1.22-2.44s-1.22 1.765-1.22 2.44zm3.849 0a1.22 1.22 0 1 0 2.44 0c0-.674-1.22-2.44-1.22-2.44s-1.22 1.765-1.22 2.44zm3.849 0a1.22 1.22 0 1 0 2.44 0c0-.674-1.22-2.44-1.22-2.44s-1.22 1.765-1.22 2.44zm5.069-2.441s-1.22 1.766-1.22 2.44a1.22 1.22 0 1 0 2.44 0c0-.674-1.22-2.44-1.22-2.44z",
  style: {"fill-rule":"evenodd","clip-rule":"evenodd"}
}, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }